import styled, { css } from "styled-components";

import {
  DeleteButton,
  DeleteButtonWrapper,
  FixedWrapper,
} from "@FillInTableContainer/shared/styles/deleteButton.style";
import { DefaultDraggableGroupShellWrapper } from "@FillInTableContainer/shared/styles/groupShell.style";
import { SectionOutsideWrapper } from "@FillInTableContainer/shared/styles/groupShellSection.style";
import {
  DefaultDeleteTableButton,
  DefaultDeleteTableButtonWrapper,
  DefaultGroupShellWrapper,
  TableContentWrapper,
} from "@FillInTableContainer/shared/styles/table.style";
import { ScrollTableWrapper } from "@FillInTableContainer/shared/styles/tableScroll.style";

export const TableWrapper = styled(TableContentWrapper)`
  gap: 0;
`;

// Asset Transfer 테이블이 가로로 넘칠 때 가로 스크롤이 생기도록(LA&SC Rights Scope 참고).
export const ScrollWrapper = styled(ScrollTableWrapper)``;

export const ScrollContentsWrapper = styled.div`
  width: fit-content;
`;

export const GroupShellSpaceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.color.neural.white};
`;

export const GroupShellWrapper = styled(DefaultGroupShellWrapper)``;

export const DeleteTableButtonWrapper = styled(
  DefaultDeleteTableButtonWrapper,
)``;

export const Title = styled.div`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-size: 1.4rem;
  font-family: var(--font-pretendard);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 145%; /* 2.03rem */
`;
export const DeleteTableButton = styled(DefaultDeleteTableButton)``;
export const DraggableGroupShellWrapper = styled(
  DefaultDraggableGroupShellWrapper,
)``;

export const GroupShellSectionWrapper = styled(SectionOutsideWrapper)`
  margin-bottom: 1.6rem;
`;

export const FixedDeleteButtonWrapper = styled(FixedWrapper)<{
  isShellTitle?: boolean;
}>`
  top: -2.4rem;
  left: -0.2rem;
  right: auto;

  ${({ isShellTitle }) =>
    isShellTitle &&
    css`
      top: -2.6rem;
      left: -0.2rem;
    `}
`;

export const DeleteGroupShellSectionButtonWrapper = styled(
  DeleteButtonWrapper,
)``;

export const DeleteGroupShellSectionButton = styled(DeleteButton)``;

// Asset Transfer(rights scope) 테이블의 컬럼 헤더 행.
// 행(그룹쉘)의 SELECT divider(그룹+서브그룹 1.6rem×2) 만큼 들여써서 셀과 좌측 정렬.
export const AssetTransferHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  padding-left: 4.2rem;
  border: 2px solid transparent;
  margin-bottom: -0.6rem;
`;

export const AssetTransferHeader = styled.div<{
  minWidth: string;
  maxWidth: string;
}>`
  display: flex;
  min-width: ${({ minWidth }) => minWidth};
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  padding: 0.6rem 0.8rem;
  align-items: flex-start;
  flex: 1 0 0;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;
  background-color: #fff;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 130%;
`;
